import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'login-dialog',
    templateUrl: 'login-dialog.component.html',
  })
  export class LoginDialog {


    constructor(
        public dialogRef: MatDialogRef<LoginDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
           
        }

        close(){
            this.dialogRef.close();
        }

  }